import { EntityName, Page } from '@/components';
import TextSeatchFilter from '@/components/TextSearchFilter/TextSearchFilter';
import { tokensMapping } from '@/utils/tokens';
import { CryptoIcon, Flex, Heading, useTableProps } from '@blockanalitica/ui';
import STUSDSSuppliersChart from './stUSDSSuppliersChart';
import STUSDSSuppliersTable from './stUSDSSuppliersTable';

export default function STUSDSSuppliersPage() {
  const { pagination, sorting, filters } = useTableProps({
    filtersDebounceTime: 250,
    pageSize: 10,
    initialSorting: '-balance',
    initialFilters: {
      textSearch: ''
    }
  });
  return (
    <Page
      title={
        <EntityName
          symbol1={
            <CryptoIcon
              name={'stUSDS'}
              address={tokensMapping('stUSDS').address}
              size="4"
            />
          }>
          <Heading size="1">stUSDS Rate Suppliers</Heading>
        </EntityName>
      }>
      <STUSDSSuppliersChart />
      <Flex flexDirection="row" alignItems="center" justifyContent="flex-end">
        <TextSeatchFilter
          filters={filters}
          placeholder="Search by wallet address"
        />
      </Flex>
      <STUSDSSuppliersTable
        pagination={pagination}
        sorting={sorting}
        search={filters.filtersApplied['textSearch']}
      />
    </Page>
  );
}
